import React, { useState, useEffect } from "react";
import { Navigation } from "./components/navigation";
import { Header } from "./components/header";
import { About } from "./components/about";
import { Thriller } from "./components/thriller";
import { Historische } from "./components/historische";
import { Testimonials } from "./components/testimonials";
import { Impressum } from "./components/impressum";
import CookieConsent from "react-cookie-consent";

import JsonData from "./data/data.json";
import SmoothScroll from "smooth-scroll";
import "./App.css";

export const scroll = new SmoothScroll('a[href*="#"]', {
  speed: 1000,
  speedAsDuration: true,
  offset: 130,
  popstate: true,
});

const App = () => {
  const [landingPageData, setLandingPageData] = useState({});
  useEffect(() => {
    setLandingPageData(JsonData);
  }, []);

  return (
    <div>
      <CookieConsent
        location="bottom"
        enableDeclineButton
        buttonText="Alle Akzeptieren!"
        declineButtonText="Alle Ablehnen!"
        cookieName="keksZugestimmt"
        style={{ background: "#2B373B", color: "#ffffff" }}
        buttonStyle={{ color: "#4e503b", fontSize: "13px" }}
        expires={150}
      >
        <h2>Nutzung von Cookies: Wir benötigen Ihre Einwilligung</h2>
        <p>
          Wir verwenden auf dieser Webseite Cookies. Diese verarbeiten auch
          personenbezogene Daten.
        </p>
        <p>
          {" "}
          Zum Einsatz kommen auf unserer Seite:
          <ul>
            <li>Technisch notwendige Cookies</li>
            <li>Statistik-Cookies</li>
            <li>Cookies von Drittanbietern (BoD)</li>
          </ul>
        </p>
        <span style={{ fontSize: "10px" }}>
          Durch einen Klick auf das Auswahlfeld „Alle akzeptieren“ stimmen Sie
          der Verwendung aller Cookies zu, die unter „Cookie-Einstellungen“
          beschrieben werden. <br />
          Sie können Ihre Einwilligung zur Nutzung von Cookies zu jeder Zeit
          ändern oder widerrufen.
        </span>
      </CookieConsent>

      <Navigation />
      <Header data={landingPageData.Header} />
      <About data={landingPageData.About} />
      <Thriller data={landingPageData.Thriller} />
      <Testimonials data={landingPageData.Testimonials} />
      <Historische data={landingPageData.Historische} />
      <Impressum />
    </div>
  );
};

export default App;
